import _ from 'lodash';
import { createContext, useContext, useEffect, useReducer } from 'react';
import { DataManagementContext } from '../../components/viewers/DataManagementViewer';
import { gEnums } from '../../enums/globalEnums';
import { googleSheetsHandlers, googleSheetsInitialState, googleSheetsReducer, googleSheetsTypes } from '../reducers/GoogleSheetsReducer';
import { ParentContext } from './ParentContext';
import { useAppUserAccess } from './useHelpers/useAppUserAccess';

/** AppContext */
export const GoogleSheetsContext = createContext();

/** Global OtherDatas for the Event */
const GoogleSheetsProvider = (props) => {

  const { googleSheetsType } = props ?? {}

  const parentContext = useContext(ParentContext)
  const { states, fns, handlers, settings, fn_cls } = parentContext ?? {}
  const { appUser_state, appSettings_state, eventInfo_state, paps_state, currentSettings_state } = states ?? {}
  const { appSettings_handlers, eventInfo_handlers } = handlers ?? {}
  const { appSettings_fns, database_fns } = fns
  const { homeSettings } = settings ?? {}
  const { global: homeSettings_global } = homeSettings ?? {}
  const { globalAppSettings, logging } = homeSettings_global ?? {}
  const { databaseProjectId } = globalAppSettings ?? {}
  const { dataRefreshOn, tempDataSource, tempGoogleSheetsId } = appSettings_state ?? {}

  const { gvviSettings } = currentSettings_state ?? {}
  const { aps_global, aps_views, aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});

  const { appUsers } = appUser_state ?? {}
  const appUserAccess = useAppUserAccess(appUsers)
  const { isSuperAdmin, email: authEmail } = appUserAccess ?? {}

  // papsContext 
  const { pathViews, appViewMode, pathModes } = paps_state ?? {}
  const { demo: demo_pathView } = pathViews ?? {}

  // pageContext   
  const { googleSheets, googleForms, googleSheetsImportOptions, appDataSource, dataOptions } = aps_global ?? {}
  const { appDataSourceType, useAppDataLinks } = appDataSource ?? {}
  const { googleSheetsId } = googleSheets ?? {}
  const { googleFormsResponseId } = googleForms ?? {}
  const { dateFormat } = dataOptions ?? {}

  const _appDataSourceType = tempDataSource ? tempDataSource : appDataSourceType

  // eventInfoContext  
  const {
    staticViews,
    appDataLinks,
    appDataDocuments,
    googleSheetsData: googleSheetsData_event,
    googleSheetsPreview: googleSheetsPreview_event
  } = eventInfo_state ?? {}

  // dataManagementContext
  const dataManagementContext = useContext(DataManagementContext)
  const { dataManagement_state } = dataManagementContext ?? {}

  const forDataManagement = dataManagement_state ? true : false

  // googleSheets
  const appInfo = { gvviSettings, staticViews, aps_viewItems, aps_views }
  const googleSheets_initState = { fn_cls, authEmail, database_fns, appSettings_fns, googleSheetsData: googleSheetsData_event, googleSheetsPreview: googleSheetsPreview_event, appInfo, pathViews, databaseProjectId, googleSheetsImportOptions, forDataManagement, useAppDataLinks, appDataLinks, appDataSource, appDataDocuments, logging }
  const [googleSheets_state, googleSheets_dispatch] = useReducer(googleSheetsReducer, googleSheetsInitialState(googleSheets_initState));
  const googleSheets_handlers = googleSheetsHandlers(googleSheets_dispatch, googleSheets_state)

  const { googleSheetsOn, googleSheetsData, staticViews: staticViews_googleSheets, googleSheetsPreview } = googleSheets_state ?? {}
  const { projectSettings } = googleSheetsPreview ?? {}

  useEffect(() => {
    if (demo_pathView) {
      googleSheets_handlers.handleGet_googleSheet(demo_pathView, null, true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [demo_pathView]);

  useEffect(() => {
    if (googleSheetsId) {
      switch (appViewMode) {
        case gEnums.appViewModes.googleSheets:
          appSettings_handlers.handleDataSourceType(gEnums.dataSourceTypes.googleSheet)
          break;
        default:
        // nothing
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appViewMode]);

  useEffect(() => {
    if (googleSheetsId && !googleSheetsData) {
      // if (isSuperAdmin && googleSheetsType === googleSheetsTypes.app) {
      //   googleSheets_handlers.handleGet_googleSheet(googleSheetsId)
      // } else {
      switch (googleSheetsType) {
        case googleSheetsTypes.normal:
          if (googleSheetsImportOptions) { googleSheetsImportOptions.dateFormat = dateFormat }
          googleSheets_handlers.handleGet_googleSheet(googleSheetsId)
          break;
        case googleSheetsTypes.registration:
          googleSheets_handlers.handleGet_googleSheet(googleFormsResponseId)
          break;
        case googleSheetsTypes.app:
          switch (_appDataSourceType) {
            case gEnums.dataSourceTypes.googleSheet:
              if (googleSheetsImportOptions) { googleSheetsImportOptions.dateFormat = dateFormat }
              googleSheets_handlers.handleStartUpdate()
              const _googleSheetsId = tempGoogleSheetsId ? tempGoogleSheetsId : googleSheetsId
              googleSheets_handlers.handleGet_googleSheet(_googleSheetsId, null, true)
              break;
            default:
            // nothing
          }
          break;
        default:
        // nothing
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [googleSheetsId, googleFormsResponseId, dataRefreshOn, _appDataSourceType]);

  // updates the eventInfo.staticViews_gs
  useEffect(() => {
    if (projectSettings) {
      // preview_handlers.handleSettings_googleSheets(projectSettings)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectSettings]);

  // useEffect(() => {
  //   // if settings_preview_changed, update the preview 
  //   if (settings_preview && settingsPreviewOn) {
  //     preview_handlers.handleSettings_preview(settings_preview, settingsPreviewOn, settingsPreviewStatus)
  //   }
  //   // eslint-disable-next-line
  // }, [settings_preview_changed]);

  // updates the eventInfo.staticViews_gss
  useEffect(() => {
    if (eventInfo_handlers) {
      if (pathModes.event) {
        switch (_appDataSourceType) {
          case gEnums.dataSourceTypes.googleSheet:
            eventInfo_handlers.handleSet_googleSheetsStaticViews(staticViews_googleSheets)
            break;
          default:
            eventInfo_handlers.handleSet_googleSheetsStaticViews(null)
            break;
        }
        if (googleSheetsData && !googleSheetsData_event) {
          if (appDataSourceType === gEnums.dataSourceTypes.googleSheet) {
            googleSheetsPreview.projectSettings.global.appDataSource.appDataSourceType = _appDataSourceType
          }
          eventInfo_handlers.handleSet_googleSheetsData(googleSheetsData, googleSheetsPreview)
        }
      }
    } else {
      eventInfo_handlers.handleClear_googleSheetsData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [googleSheetsData, _appDataSourceType]);

  const providerContext = () => <GoogleSheetsContext.Provider
    value={{ googleSheets_handlers: googleSheets_handlers, googleSheets_state: googleSheets_state }}>
    {props.children}
  </GoogleSheetsContext.Provider>

  switch (_appDataSourceType) {
    case gEnums.dataSourceTypes.googleSheet:
      return googleSheetsData ? providerContext() : providerContext()
    default:
      if (googleSheetsOn || isSuperAdmin) {
        return googleSheetsData ? providerContext() : providerContext()
      } else {
        return providerContext()
      }
  }
}

export default GoogleSheetsProvider